import React, { useEffect, useState } from "react";
import T from '../../components/common/T';
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import DataTable from "../../components/common/DataTables.jsx";
import PageHeader from "../../components/common/PageHeader";

import { useAuth } from "../../context/AuthContext";
import TableActionButtons from "../../components/common/TableActionButtons";

const VendorListView = ({ searchTerm = "", vendors = [], onDelete }) => {
  const navigate = useNavigate();
  const { checkAccess } = useAuth();

  const [list, setList] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [currentHistory, setCurrentHistory] = useState([]);

  useEffect(() => { setList(vendors); }, [vendors]);

  const handleDelete = (id, name) => {
    if (onDelete) onDelete(id);
    else console.error("Delete function not passed to ListView");
  };

  const showHistory = (history) => {
    setCurrentHistory(history || []);
    setModalOpen(true);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Active": return "bg-green-50 text-green-700 border border-green-200";
      case "Pending": return "bg-orange-50 text-orange-700 border border-orange-200";
      case "Inactive": return "bg-gray-50 text-gray-600 border border-gray-200";
      case "Blacklisted": return "bg-red-50 text-red-700 border border-red-200";
      default: return "bg-gray-50 text-gray-700 border border-gray-200";
    }
  };

  const cap = (s) => (!s ? "" : s.charAt(0).toUpperCase() + s.slice(1));

  const filteredList = list.filter((v) => v.vendorName?.toLowerCase().includes(searchTerm.toLowerCase()));

  const columns = [
    { header: "ID", accessor: "id", sortable: true, render: (v) => <span className="font-mono text-gray-500 text-[11px]">{v.id}</span> },
    { header: "Vendor Name", accessor: "vendorName", sortable: true, render: (v) => <span className="font-semibold text-gray-900">{v.vendorName}</span> },
    { header: "Category", accessor: "category", sortable: true, render: (v) => <span className="text-gray-600 text-xs">{v.category}</span> },
    {
      header: "Status",
      accessor: "vendorStatus",
      align: "center",
      sortable: true,
      render: (v) => {
        const status = cap(v.vendorStatus || v.performanceStatus || "Pending");
        return (
          <span
            className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wide cursor-pointer hover:shadow-sm transition ${getStatusColor(status)}`}
            onClick={() => showHistory(v.history)}
            title="Click to view history"
          >
            {status}
          </span>
        );
      }
    },
    {
      header: "Actions",
      align: "right",
      render: (v) => (
        <TableActionButtons
          onView={() => navigate(`/admin/VendorPage/view/${v.id}`)}
          onEdit={checkAccess('vendor.manage') ? () => navigate(`/admin/VendorPage/edit/${v.id}`) : undefined}
          onDelete={checkAccess('vendor.manage') ? () => handleDelete(v.id, v.vendorName) : undefined}
        />
      )
    }
  ];

  return (
    <>
      <div className="relative">
        <DataTable data={filteredList} columns={columns} tableId="vendors" emptyMessage="No vendors found." />
      </div>

      {modalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50 backdrop-blur-sm animate-fade-in">
          <div className="bg-white rounded-xl shadow-2xl p-6 w-96 max-h-[80vh] flex flex-col">
            <h2 className="text-base font-bold mb-4 text-gray-900 border-b pb-2"><T>Status History</T></h2>
            <div className="overflow-y-auto flex-1 mb-4">
                {currentHistory.length === 0 ? (
                <p className="text-gray-400 text-sm italic"><T>No history available.</T></p>
                ) : (
                <ul className="space-y-3">
                    {currentHistory.map((h, i) => (
                    <li key={i} className="flex flex-col text-sm border-l-2 border-indigo-200 pl-3 py-1">
                        <span className="font-semibold text-gray-800">{h.message}</span>
                        <span className="text-gray-400 text-[10px] mt-0.5">{h.date}</span>
                    </li>
                    ))}
                </ul>
                )}
            </div>
            <button onClick={() => setModalOpen(false)} className="mt-auto bg-gray-100 text-gray-700 font-semibold px-4 py-2 rounded border border-gray-300 hover:bg-gray-200 transition text-sm"><T>Close</T></button>
          </div>
        </div>
      )}
    </>
  );
};

export default VendorListView;